
import React, {useEffect, useState} from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useForm } from "react-hook-form"
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import { Navigate, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { ApiUrl, Headers } from '../services/ApiUrl';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';


function FormPP2023({user, setUser}) {
  
  const[proyectoActivo, setProyectoActivo] = useState([])
  const[recargar, setRecargar] = useState(false)
  const [modalShow, setModalShow] = useState(false);
  const [stateAdjunto, setStateAdjunto] = useState("")
  const [guardandoProyecto, setGuardandoProyecto] = useState("")
  const [visible, setIsVisible] = useState(false);


  const navigate = useNavigate();
  const navegarTo = (destino) => {
      const destinourl = '/' + destino;
      navigate(destinourl);
  }    

  const onSubmit = (data) => {
    //console.log(data) 
    setGuardandoProyecto(true)    
    let formData = new FormData();
    let filesid =  data.imagen_destacada;
    if (filesid){
    Array.from(filesid).forEach(file => {
        formData.append("files_id[]", file); 
      }
    );  
    }
    let filesi1 =  data.imagen1_url;
    if (filesi1){
    Array.from(filesi1).forEach(file => {
        formData.append("files_i1[]", file); 
      }
    );  
    }
    let filesi2 =  data.imagen2_url;
    if (filesi2){
    Array.from(filesi2).forEach(file => {
        formData.append("files_i2[]", file); 
      }
    );  
    }
    let filesi3 =  data.imagen3_url;
    if (filesi3){
    Array.from(filesi3).forEach(file => {
        formData.append("files_i3[]", file); 
      }
    );  
    }
    let filesdpdf =  data.documento_pdf;
    if (filesdpdf){
    Array.from(filesdpdf).forEach(file => {
        formData.append("files_dpdf[]", file); 
      }
    );  
    }    
    
    formData.append('titulo_proyecto', data.titulo_proyecto); 
    formData.append('acciones_y_tareas', data.acciones_y_tareas); 
    formData.append('antecedentes_fundamentacion', data.antecedentes_fundamentacion);
    formData.append('aval1_dni', data.aval1_dni);
    formData.append('aval1_nombre', data.aval1_nombre);
    formData.append('aval2_dni', data.aval2_dni);
    formData.append('aval2_nombre', data.aval2_nombre);    
    formData.append('aval3_dni', data.aval3_dni);
    formData.append('aval3_nombre', data.aval3_nombre);
    formData.append('aval4_dni', data.aval4_dni);
    formData.append('aval4_nombre', data.aval4_nombre);
    formData.append('aval5_dni', data.aval5_dni);
    formData.append('aval5_nombre', data.aval5_nombre);
    formData.append('beneficiarios_destinatarios', data.beneficiarios_destinatarios);
    formData.append('categoria_proyecto', data.categoria_proyecto);
    formData.append('descripcion_proyecto', data.descripcion_proyecto);
    formData.append('diagnostico', data.diagnostico);
    formData.append('documento_nombre', data.documento_nombre);  
    formData.append('id_user', data.id_user);  
    formData.append('imagen1_nombre', data.imagen1_nombre);  
    formData.append('imagen2_nombre', data.imagen2_nombre);  
    formData.append('imagen3_nombre', data.imagen3_nombre);  
    formData.append('localidad_proyecto', data.localidad_proyecto);  
    formData.append('localizacion', data.localizacion);
    formData.append('localizacion', data.localizacion);
    formData.append('localizacion', data.localizacion);
    formData.append('localizacion', data.localizacion);
    formData.append('localizacion', data.localizacion);
    formData.append('localizacion', data.localizacion);
    formData.append('monto_total_estimado', data.monto_total_estimado);
    formData.append('nombre_grupo', data.nombre_grupo);
    formData.append('objetivo_general', data.objetivo_general);
    formData.append('objetivos_especificos', data.objetivos_especificos);
    formData.append('recursos_financieros', data.recursos_financieros);
    formData.append('recursos_humanos', data.recursos_humanos);
    formData.append('recursos_materiales', data.recursos_materiales);
    formData.append('tipo_proyecto', data.tipo_proyecto);
           
    let url = ApiUrl + 'presentarproyecto';   
    axios.post(url, formData,
    {headers:Headers},
    ) 
    .then( response =>{     
                //console.log(response)  
                setIsVisible(true);
                document.getElementById("presentar-proyecto").disabled = true;
                setTimeout(function() {
                    navegarTo('panelusuarioproyectos')   
                }, 5000);            
    
    }).catch( error=>{

    })
    .finally(function () {
      setGuardandoProyecto(false)
    });        
  }

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues:{
    id_user:user.id_user,
    
    }
  })


  const handleClose =()=>{
    setModalShow(false)
  }
  const eliminarAdjunto=(adjunto)=>{
    //reciber los parametros y se los manda al modal
    // y el modal elimina
    setStateAdjunto(adjunto)
    setModalShow(true)    
  }

  const confirmarEliminar=(adjunto)=>{
  // con el id del proyecto vacío el campo adjunto
  let url = ApiUrl + 'pp2023_proyectos?id='+ proyectoActivo.id_proyecto +'&nameId=id_proyecto';  
  if(adjunto==="imagen_destacada"){  
      axios.put(url,{imagen_destacada:''}, 
        {headers:Headers})
      .then( response =>{        
            setProyectoActivo({
              ...proyectoActivo,
              imagen_destacada: ""
            })                               
          handleClose() 
      }).catch( error=>{        
      })     
  }
  if(adjunto==="imagen1_url"){  
    axios.put(url,{imagen1_url:''}, 
      {headers:Headers})
    .then( response =>{        
          setProyectoActivo({
            ...proyectoActivo,
            imagen1_url: ""
          })                             
        handleClose() 
    }).catch( error=>{        
    })     
  }
  if(adjunto==="imagen2_url"){  
    axios.put(url,{imagen2_url:''}, 
      {headers:Headers})
    .then( response =>{        
          setProyectoActivo({
            ...proyectoActivo,
            imagen2_url: ""
          })                             
        handleClose() 
    }).catch( error=>{        
    })     
  }  
  if(adjunto==="imagen3_url"){  
    axios.put(url,{imagen3_url:''}, 
      {headers:Headers})
    .then( response =>{                
          setProyectoActivo({
            ...proyectoActivo,
            imagen3_url: ""
          })                     
        handleClose() 
    }).catch( error=>{        
    })     
  }  
  if(adjunto==="documento_pdf"){  
    axios.put(url,{documento_pdf:''}, 
      {headers:Headers})
    .then( response =>{        
          setProyectoActivo({
            ...proyectoActivo,
            documento_pdf: ""
          })                             
        handleClose() 
    }).catch( error=>{        
    })     
  }  
  setRecargar(true)
  }

  const cargarProyectos= ()=>{
    
      let url = ApiUrl + 'pp2023_proyectos?select=*&linkTo=id_user&equalTo='+user.id_user
      axios.get(url, {headers:Headers})
      .then( response =>{
          setProyectoActivo(response.data.results[0])                    
          setValue('nombre_grupo', response.data.results[0].nombre_grupo);
          setValue('acciones_y_tareas', response.data.results[0].acciones_y_tareas);
          setValue('antecedentes_fundamentacion', response.data.results[0].antecedentes_fundamentacion);
          //setValue('acciones_y_tareas', response.data.results[0].antecedentes_fundamentacion);
          //setValue('acciones_y_tareas', response.data.results[0].antecedentes_fundamentacion);
          setValue('aval1_dni', response.data.results[0].aval1_dni);
          setValue('aval1_nombre', response.data.results[0].aval1_nombre);
          setValue('aval2_dni', response.data.results[0].aval2_dni);
          setValue('aval2_nombre', response.data.results[0].aval2_nombre);
          setValue('aval3_dni', response.data.results[0].aval3_dni);
          setValue('aval3_nombre', response.data.results[0].aval3_nombre);
          setValue('aval4_dni', response.data.results[0].aval4_dni);
          setValue('aval4_nombre', response.data.results[0].aval4_nombre);
          setValue('aval5_dni', response.data.results[0].aval5_dni);
          setValue('aval5_nombre', response.data.results[0].aval5_nombre);
          setValue('beneficiarios_destinatarios', response.data.results[0].beneficiarios_destinatarios);
          setValue('categoria_proyecto', response.data.results[0].categoria_proyecto);
          setValue('descripcion_proyecto', response.data.results[0].descripcion_proyecto);
          setValue('documento_nombre', response.data.results[0].documento_nombre);
          setValue('diagnostico', response.data.results[0].diagnostico);
          setValue('documento_pdf', "");
          setValue('id_user', response.data.results[0].id_user);
          setValue('imagen_destacada', "");
          setValue('imagen1_nombre', response.data.results[0].imagen1_nombre);
          setValue('imagen1_url', "");
          setValue('imagen2_nombre', response.data.results[0].imagen2_nombre);
          setValue('imagen2_url', "");
          setValue('imagen3_nombre', response.data.results[0].imagen3_nombre);
          setValue('imagen3_url', "");
          setValue('localidad_proyecto', response.data.results[0].localidad_proyecto);
          setValue('localizacion', response.data.results[0].localizacion);
          setValue('monto_total_estimado', response.data.results[0].monto_total_estimado);
          setValue('nombre_grupo', response.data.results[0].nombre_grupo);
          setValue('objetivo_general', response.data.results[0].objetivo_general);
          setValue('objetivos_especificos', response.data.results[0].objetivos_especificos);
          setValue('recursos_financieros', response.data.results[0].recursos_financieros);
          setValue('recursos_humanos', response.data.results[0].recursos_humanos);
          setValue('recursos_materiales', response.data.results[0].recursos_materiales);
          setValue('tipo_proyecto', response.data.results[0].tipo_proyecto);
          setValue('titulo_proyecto', response.data.results[0].titulo_proyecto);

      }).catch( error=>{

          setProyectoActivo({
              id_proyecto: 0,
              imagen_destacada: "",
              imagen1_url: "",
              imagen2_url: "",
              imagen3_url: "",
              imagen_destacada:"",
              documento_pdf:"",
              fecha_borrador:""
          })

      })
      .finally(function () {
        // siempre sera executado
      });
      setRecargar(true)
  }
  useEffect (()=>{
      cargarProyectos() 
      setRecargar(false) 
  },[recargar]);  

  const guardarborrador = async (iscerrarsesion)=>{
    setGuardandoProyecto(true)
    let data = getValues()    
    let formData = new FormData();
    let filesid =  data.imagen_destacada;
    if (filesid){
    Array.from(filesid).forEach(file => {
        formData.append("files_id[]", file); 
      }
    );  
    }
    let filesi1 =  data.imagen1_url;
    if (filesi1){
    Array.from(filesi1).forEach(file => {
        formData.append("files_i1[]", file); 
      }
    );  
    }
    let filesi2 =  data.imagen2_url;
    if (filesi2){
    Array.from(filesi2).forEach(file => {
        formData.append("files_i2[]", file); 
      }
    );  
    }
    let filesi3 =  data.imagen3_url;
    if (filesi3){
    Array.from(filesi3).forEach(file => {
        formData.append("files_i3[]", file); 
      }
    );  
    }
    let filesdpdf =  data.documento_pdf;
    if (filesdpdf){
    Array.from(filesdpdf).forEach(file => {
        formData.append("files_dpdf[]", file); 
      }
    );  
    }    
    
    formData.append('titulo_proyecto', data.titulo_proyecto); 
    formData.append('acciones_y_tareas', data.acciones_y_tareas); 
    formData.append('antecedentes_fundamentacion', data.antecedentes_fundamentacion);
    formData.append('aval1_dni', data.aval1_dni);
    formData.append('aval1_nombre', data.aval1_nombre);
    formData.append('aval2_dni', data.aval2_dni);
    formData.append('aval2_nombre', data.aval2_nombre);    
    formData.append('aval3_dni', data.aval3_dni);
    formData.append('aval3_nombre', data.aval3_nombre);
    formData.append('aval4_dni', data.aval4_dni);
    formData.append('aval4_nombre', data.aval4_nombre);
    formData.append('aval5_dni', data.aval5_dni);
    formData.append('aval5_nombre', data.aval5_nombre);
    formData.append('beneficiarios_destinatarios', data.beneficiarios_destinatarios);
    formData.append('categoria_proyecto', data.categoria_proyecto);
    formData.append('descripcion_proyecto', data.descripcion_proyecto);
    formData.append('diagnostico', data.diagnostico);
    formData.append('documento_nombre', data.documento_nombre);  
    formData.append('id_user', data.id_user);  
    formData.append('imagen1_nombre', data.imagen1_nombre);  
    formData.append('imagen2_nombre', data.imagen2_nombre);  
    formData.append('imagen3_nombre', data.imagen3_nombre);  
    formData.append('localidad_proyecto', data.localidad_proyecto);  
    formData.append('localizacion', data.localizacion);
    formData.append('localizacion', data.localizacion);
    formData.append('localizacion', data.localizacion);
    formData.append('localizacion', data.localizacion);
    formData.append('localizacion', data.localizacion);
    formData.append('localizacion', data.localizacion);
    formData.append('monto_total_estimado', data.monto_total_estimado);
    formData.append('nombre_grupo', data.nombre_grupo);
    formData.append('objetivo_general', data.objetivo_general);
    formData.append('objetivos_especificos', data.objetivos_especificos);
    formData.append('recursos_financieros', data.recursos_financieros);
    formData.append('recursos_humanos', data.recursos_humanos);
    formData.append('recursos_materiales', data.recursos_materiales);
    formData.append('tipo_proyecto', data.tipo_proyecto);
           
    let url = ApiUrl + 'guardarborrador';   
    axios.post(url, formData,
    {headers:Headers},
    ) 
    .then( response =>{     
      if(iscerrarsesion){
        document.getElementById("guardarborrador").disabled = true;
        setTimeout(() => 
        setUser({
          error: false,
          login:false,
          name_user: '',
          token_user: '',
          errorMsg: ''
        })  
        , 1000);
       
      }               
    
    }).catch( error=>{

    })
    .finally(function () {
      setRecargar(true)
      setGuardandoProyecto(false)
    });    
  }



  return (
    <>
        {
            user.login ===false &&
            <Navigate to="/iniciarsesionproyectos" />
        } 
        {
            user.login ===true &&           
      <Form onSubmit={handleSubmit(onSubmit)} >

        <Container style={{marginTop:'50px'}}>
          <Row>
                    <Col>  
                        <h1>Formulario para carga de proyectos</h1>
                        
                        <Alert variant="success">                          
                          Puede ir guardando el borrador del proyecto a medida que cargar los datos requeridos.
                          Al volver a iniciar sesión puede seguir editando el proyecto.
                          Cuando la carga esté completa puede finalizar el proyecto con el botón Presentar el proyecto.                          
                        </Alert>  
                        
                    </Col>
          </Row>          
          <Row>            
            <Col>
              <Card>
                <Card.Header>Responsable del proyecto</Card.Header>
                <Card.Body>
                    <ListGroup className="list-group-flush">
                      <ListGroup.Item>
                        <Form.Group className="mb-3">
                          <Form.Label size="lg">Nombre y apellido</Form.Label>
                          <Form.Control type="text" placeholder="Nombre y apellido..." disabled
                          defaultValue={user.name_user} />
                        </Form.Group>                        
                      </ListGroup.Item>

                      <Form.Control type="hidden" disabled defaultValue={user.id_user}                             
                        {...register("id_user")} />                                              
                      
                      <ListGroup.Item>
                        <Form.Group className="mb-3">
                          <Form.Label size="lg">DNI</Form.Label>
                          <Form.Control type="text" placeholder="DNI..." disabled
                          defaultValue={user.dni} />
                        </Form.Group>                        
                      </ListGroup.Item>          

                      <ListGroup.Item>
                        <Form.Group className="mb-3">
                          <Form.Label size="lg">Teléfono de contacto</Form.Label>
                          <Form.Control type="text" placeholder="Teléfono..." disabled
                          defaultValue={user.telefono}/>
                        </Form.Group>                        
                      </ListGroup.Item>   

                      <ListGroup.Item>
                        <Form.Group className="mb-3">
                          <Form.Label size="lg">Correo electrónico</Form.Label>
                          <Form.Control type="text" placeholder="Correo electrónico..." disabled
                          defaultValue={user.email_user} />
                        </Form.Group>                        
                      </ListGroup.Item>    

                      <ListGroup.Item>
                        <Form.Group className="mb-3">
                          <Form.Label size="lg">Categoría proyecto</Form.Label>
                          <Form.Select aria-label="Seleccionar tipo de proyecto" 
                          {...register("categoria_proyecto", {required:"Debe seleccionar la categoría del proyecto"})} 
                          isInvalid={errors.categoria_proyecto}>
                            <option value="">Seleccionar categoría del proyecto</option>
                            {proyectoActivo.categoria_proyecto === "PP General 2023" ?
                            <option value="PP General 2023" selected>PP General 2023</option>
                            :
                            <option value="PP General 2023" >PP General 2023</option>
                            }
                            {proyectoActivo.categoria_proyecto === "PP Joven 2023" ?
                            <option value="PP Joven 2023" selected>PP Joven 2023</option>
                            :
                            <option value="PP Joven 2023">PP Joven 2023</option>
                            }                              
                        </Form.Select> 

                          {errors.categoria_proyecto &&
                          <Alert style={{marginTop:'10px' }} variant="danger">
                            {errors.categoria_proyecto?.message}
                          </Alert>
                          }

                        </Form.Group>                        
                      </ListGroup.Item>   




                      <ListGroup.Item>
                        <Form.Group className="mb-3">
                          <Form.Label size="lg">Tipo de proyecto</Form.Label>
                          <Form.Select aria-label="Seleccionar tipo de proyecto" 
                          {...register("tipo_proyecto", {required:"Debe seleccionar el tipo de proyecto"})} 
                          isInvalid={errors.tipo_proyecto}>
                            <option value="">Seleccionar tipo de proyecto</option>
                            {proyectoActivo.tipo_proyecto === "Individual" ?
                            <option value="Individual" selected>Individual</option>
                            :
                            <option value="Individual" >Individual</option>
                            }
                            {proyectoActivo.tipo_proyecto === "Grupal" ?
                            <option value="Grupal" selected>Grupal</option>
                            :
                            <option value="Grupal">Grupal</option>
                            }                            
                            {proyectoActivo.tipo_proyecto === "Comisión barrial" ?
                            <option value="Comisión barrial" selected>Comisión barrial</option>
                            :
                            <option value="Comisión barrial">Comisión barrial</option>
                            }    
                        </Form.Select> 

                          {errors.tipo_proyecto &&
                          <Alert style={{marginTop:'10px' }} variant="danger">
                            {errors.tipo_proyecto?.message}
                          </Alert>
                          }
                        </Form.Group>                        
                      </ListGroup.Item>                          

                      <ListGroup.Item>
                        <Form.Group className="mb-3">
                          <Form.Label size="lg">Nombre grupo / institución / Comisión Barrial</Form.Label>
                          <Form.Control id="nombre_grupo" type="text" placeholder="Nombre grupo / institución / Comisión Barrial..." 
                          {...register("nombre_grupo", {required:"El dato es obligatorio",    
                          })} 
                          isInvalid={errors.nombre_grupo} autoComplete='off' 
                          maxLength='100'
                          defaultValue={proyectoActivo.nombre_grupo} 
                          onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}} 
                          />
                          <Form.Text className="text-muted" muted>
                            En el caso de proyecto individual ingresar el nombre y apellido del responsable del proyecto
                          </Form.Text>                          

                          {errors.nombre_grupo &&
                          <Alert style={{marginTop:'10px' }} variant="danger">
                            {errors.nombre_grupo?.message}
                          </Alert>
                          }
                        </Form.Group>                        
                      </ListGroup.Item>    


                    </ListGroup>

                </Card.Body>
              </Card>            
            </Col>
          </Row>
        </Container>    

        <Container>
          <Row>
            <Col>
            <Card>
              <Card.Header>Avales del proyecto</Card.Header>
                  <Card.Body>  
                  <ListGroup className="list-group-flush">

                  <ListGroup.Item> 
                      <Alert variant="success">
                        Se solicitan cómo mínimo los avales de 5 vecinos/as para poder presentar un proyecto. <br/>
                        Es obligatorio ingresar el nombre y apellido y el DNI de los 5 primeros avales.                     
                      </Alert>                      
                    </ListGroup.Item>                    

                  <ListGroup.Item>
                        <Form.Group className="mb-3">
                          <Form.Label size="lg">Nombre y apellido del Aval 1</Form.Label>
                          <Form.Control type="text" placeholder="Nombre y apellido del Aval 1..." 
                          {...register("aval1_nombre", 
                          {required:"El nombre y apellido del aval son obligatorios", 
                          minLength:{value:5, message: "El mínimo de caracteres para el nombre y apellido es 5"}, 
                          maxLength:{value:100, message: "El máximo de caracteres para el nombre y apellido es 100"}, 
                          })} 
                          isInvalid={errors.aval1_nombre}
                          autoComplete='off'
                          maxLength='100'
                          onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}} 
                          />
                          {errors.aval1_nombre &&
                          <Alert style={{marginTop:'10px' }} variant="danger">
                            {errors.aval1_nombre?.message}
                          </Alert>
                          }
                        </Form.Group>                        

                        <Form.Group className="mb-3">
                          <Form.Label size="lg">DNI del Aval 1</Form.Label>
                          <Form.Control type="text" placeholder="DNI del Aval 1..." 
                          {...register("aval1_dni", 
                          {
                          required:"El DNI es obligatorio",  
                          minLength:{value:7, message: "El mínimo de caracteres para el DNI es 7"}, 
                          maxLength:{value:9, message: "El máximo de caracteres para el DNI es 9"}, 
                          pattern:{ value: /^[0-9]+$/i, message: "Ingresar sólo números, sin espacios ni puntos"}
                          })} 
                          isInvalid={errors.aval1_dni}
                          autoComplete='off'
                          maxLength='9'
                          onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}} 
                          />

                          {errors.aval1_dni &&
                          <Alert style={{marginTop:'10px' }} variant="danger">
                            {errors.aval1_dni?.message}
                          </Alert>
                          }
                        </Form.Group>                        
                      </ListGroup.Item>                                      

                      <ListGroup.Item>
                        <Form.Group className="mb-3">
                          <Form.Label size="lg">Nombre y apellido del Aval 2</Form.Label>
                          <Form.Control type="text" placeholder="Nombre y apellido del Aval 2..." 
                          {...register("aval2_nombre", 
                          {required:"El nombre y apellido del aval son obligatorios", 
                          minLength:{value:5, message: "El mínimo de caracteres para el nombre y apellido es 5"}, 
                          maxLength:{value:100, message: "El máximo de caracteres para el nombre y apellido es 100"}, 
                          })} 
                          isInvalid={errors.aval2_nombre}
                          autoComplete='off'
                          maxLength='100'
                          onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}} 
                          />
                          {errors.aval2_nombre &&
                          <Alert style={{marginTop:'10px' }} variant="danger">
                            {errors.aval2_nombre?.message}
                          </Alert>
                          }
                        </Form.Group>                        

                        <Form.Group className="mb-3">
                          <Form.Label size="lg">DNI del Aval 2</Form.Label>
                          <Form.Control type="text" placeholder="DNI del Aval 2..." 
                          {...register("aval2_dni", 
                          {
                          required:"El DNI es obligatorio",  
                          minLength:{value:7, message: "El mínimo de caracteres para el DNI es 7"}, 
                          maxLength:{value:9, message: "El máximo de caracteres para el DNI es 9"}, 
                          pattern:{ value: /^[0-9]+$/i, message: "Ingresar sólo números, sin espacios ni puntos"}
                          })} 
                          isInvalid={errors.aval2_dni}
                          autoComplete='off'
                          maxLength='9'
                          onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}} 
                          />

                          {errors.aval2_dni &&
                          <Alert style={{marginTop:'10px' }} variant="danger">
                            {errors.aval2_dni?.message}
                          </Alert>
                          }
                        </Form.Group>                        
                      </ListGroup.Item>  

                      <ListGroup.Item>
                        <Form.Group className="mb-3">
                          <Form.Label size="lg">Nombre y apellido del Aval 3</Form.Label>
                          <Form.Control type="text" placeholder="Nombre y apellido del Aval 3..." 
                          {...register("aval3_nombre", 
                          {required:"El nombre y apellido del aval son obligatorios", 
                          minLength:{value:5, message: "El mínimo de caracteres para el nombre y apellido es 5"}, 
                          maxLength:{value:100, message: "El máximo de caracteres para el nombre y apellido es 100"}, 
                          })} 
                          isInvalid={errors.aval3_nombre}
                          autoComplete='off'
                          maxLength='100'
                          onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}} 
                          />
                          {errors.aval3_nombre &&
                          <Alert style={{marginTop:'10px' }} variant="danger">
                            {errors.aval3_nombre?.message}
                          </Alert>
                          }
                        </Form.Group>                        

                        <Form.Group className="mb-3">
                          <Form.Label size="lg">DNI del Aval 3</Form.Label>
                          <Form.Control type="text" placeholder="DNI del Aval 3..." 
                          {...register("aval3_dni", 
                          {
                          required:"El DNI es obligatorio",  
                          minLength:{value:7, message: "El mínimo de caracteres para el DNI es 7"}, 
                          maxLength:{value:9, message: "El máximo de caracteres para el DNI es 9"}, 
                          pattern:{ value: /^[0-9]+$/i, message: "Ingresar sólo números, sin espacios ni puntos"}
                          })} 
                          isInvalid={errors.aval3_dni}
                          autoComplete='off'
                          maxLength='9'
                          onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}} 
                          />

                          {errors.aval3_dni &&
                          <Alert style={{marginTop:'10px' }} variant="danger">
                            {errors.aval3_dni?.message}
                          </Alert>
                          }
                        </Form.Group>                        
                      </ListGroup.Item>   

                      <ListGroup.Item>
                        <Form.Group className="mb-3">
                          <Form.Label size="lg">Nombre y apellido del Aval 4</Form.Label>
                          <Form.Control type="text" placeholder="Nombre y apellido del Aval 4..." 
                          {...register("aval4_nombre", 
                          {required:"El nombre y apellido del aval son obligatorios", 
                          minLength:{value:5, message: "El mínimo de caracteres para el nombre y apellido es 5"}, 
                          maxLength:{value:100, message: "El máximo de caracteres para el nombre y apellido es 100"}, 
                          })} 
                          isInvalid={errors.aval4_nombre}
                          autoComplete='off'
                          maxLength='100'
                          onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}} 
                          />
                          {errors.aval4_nombre &&
                          <Alert style={{marginTop:'10px' }} variant="danger">
                            {errors.aval4_nombre?.message}
                          </Alert>
                          }
                        </Form.Group>                        

                        <Form.Group className="mb-3">
                          <Form.Label size="lg">DNI del Aval 4</Form.Label>
                          <Form.Control type="text" placeholder="DNI del Aval 4..." 
                          {...register("aval4_dni", 
                          {
                          required:"El DNI es obligatorio",  
                          minLength:{value:7, message: "El mínimo de caracteres para el DNI es 7"}, 
                          maxLength:{value:9, message: "El máximo de caracteres para el DNI es 9"}, 
                          pattern:{ value: /^[0-9]+$/i, message: "Ingresar sólo números, sin espacios ni puntos"}
                          })} 
                          isInvalid={errors.aval4_dni}
                          autoComplete='off'
                          maxLength='9'
                          onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}} 
                          />

                          {errors.aval4_dni &&
                          <Alert style={{marginTop:'10px' }} variant="danger">
                            {errors.aval4_dni?.message}
                          </Alert>
                          }
                        </Form.Group>                        
                      </ListGroup.Item>       

                      <ListGroup.Item>
                        <Form.Group className="mb-3">
                          <Form.Label size="lg">Nombre y apellido del Aval 5</Form.Label>
                          <Form.Control type="text" placeholder="Nombre y apellido del Aval 5..." 
                          {...register("aval5_nombre", 
                          {required:"El nombre y apellido del aval son obligatorios", 
                          minLength:{value:5, message: "El mínimo de caracteres para el nombre y apellido es 5"}, 
                          maxLength:{value:100, message: "El máximo de caracteres para el nombre y apellido es 100"}, 
                          })} 
                          isInvalid={errors.aval5_nombre}
                          autoComplete='off'
                          maxLength='100'
                          onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}} 
                          />
                          {errors.aval5_nombre &&
                          <Alert style={{marginTop:'10px' }} variant="danger">
                            {errors.aval5_nombre?.message}
                          </Alert>
                          }
                        </Form.Group>                        

                        <Form.Group className="mb-3">
                          <Form.Label size="lg">DNI del Aval 5</Form.Label>
                          <Form.Control type="text" placeholder="DNI del Aval 5..." 
                          {...register("aval5_dni", 
                          {
                          required:"El DNI es obligatorio",  
                          minLength:{value:7, message: "El mínimo de caracteres para el DNI es 7"}, 
                          maxLength:{value:9, message: "El máximo de caracteres para el DNI es 9"}, 
                          pattern:{ value: /^[0-9]+$/i, message: "Ingresar sólo números, sin espacios ni puntos"}
                          })} 
                          isInvalid={errors.aval5_dni}
                          autoComplete='off'
                          maxLength='9'
                          onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}} 
                          />

                          {errors.aval5_dni &&
                          <Alert style={{marginTop:'10px' }} variant="danger">
                            {errors.aval5_dni?.message}
                          </Alert>
                          }
                        </Form.Group>                        
                      </ListGroup.Item>                                                               

                  
                  </ListGroup>

                  </Card.Body> 
            </Card>
            </Col>
          </Row>
        </Container>            
        
        <Container style={{marginTop:'30px'}}>
          <Row>
            <Col>
              <Card>
                <Card.Header>Datos del proyecto</Card.Header>
                  <Card.Body>            

                  <ListGroup className="list-group-flush">
                    
                    <ListGroup.Item>
                      <Form.Group className="mb-3">
                        <Form.Label size="lg">Título del proyecto</Form.Label>
                        <Form.Control type="text" placeholder="Ingresar el título del proyecto..." 
                        {...register("titulo_proyecto", 
                        {required:"El título del proyecto es obligatorio", 
                        minLength:{value:5, message: "El mínimo de caracteres para el título es 5"}, 
                        maxLength:{value:100, message: "El máximo de caracteres para el título es 100"}, 
                        })} 
                        isInvalid={errors.titulo_proyecto}
                        autoComplete='off'
                        maxLength='100'
                        onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}} 
                        />
                        <Form.Text className="text-muted" muted>
                          Ingrese un máximo de 100 caracteres  ({ watch('titulo_proyecto') ? (watch('titulo_proyecto').length)+"/100" : '0/100' })
                        </Form.Text>
                        {errors.titulo_proyecto &&
                        <Alert style={{marginTop:'10px' }} variant="danger">
                          {errors.titulo_proyecto?.message}                    
                        </Alert>
                        }
                      </Form.Group> 
                    </ListGroup.Item>             

                    <ListGroup.Item>
                      <Form.Group className="mb-3">
                        <Form.Label>Localidad del proyecto</Form.Label>
                        <Form.Select aria-label="Seleccionar localidad" 
                          {...register("localidad_proyecto", {required:"Debe seleccionar la localidad"})} 
                          isInvalid={errors.localidad_proyecto}
                        >
                            <option value="">Seleccionar localidad</option>
                            {proyectoActivo.localidad === "Trenque Lauquen" ?
                            <option value="Trenque Lauquen" selected>Trenque Lauquen</option>
                            :
                            <option value="Trenque Lauquen">Trenque Lauquen</option>
                            }                              
                            {proyectoActivo.localidad === "30 de Agosto" ?
                            <option value="30 de Agosto" selected>30 de Agosto</option>
                            :
                            <option value="30 de Agosto">30 de Agosto</option>
                            }    
                            {proyectoActivo.localidad === "Beruti" ?
                            <option value="Beruti" selected>Beruti</option>
                            :
                            <option value="Beruti">Beruti</option>
                            }  
                            {proyectoActivo.localidad === "Garré" ?
                            <option value="Garré" selected>Garré</option>
                            :
                            <option value="Garré">Garré</option>
                            } 
                            {proyectoActivo.localidad === "Girodias" ?
                            <option value="Girodias" selected>Girodias</option>
                            :
                            <option value="Girodias">Girodias</option>
                            }
                      
                        </Form.Select>   
                        {errors.localidad_proyecto &&
                        <Alert style={{marginTop:'10px' }} variant="danger">
                          {errors.localidad_proyecto?.message}
                        </Alert>
                        }                
                      </Form.Group>                        
                    </ListGroup.Item> 

                    <ListGroup.Item>
                      <Form.Group className="mb-3">
                        <Form.Label size="lg">Descripción del proyecto</Form.Label>
                        <Form.Control as="textarea" rows={4} placeholder="Ingresar la descripción del proyecto..." 
                        {...register("descripcion_proyecto", 
                        {required:"La descripción del proyecto es obligatorio", 
                        minLength:{value:5, message: "El mínimo de caracteres para la descripción es 5"}, 
                        maxLength:{value:500, message: "El máximo de caracteres para la descripción 500"}, 
                        })} 
                        isInvalid={errors.descripcion_proyecto}
                        autoComplete='off'
                        maxLength='500'
                        
                        />
                        <Form.Text className="text-muted" muted>
                          Ingrese un máximo de 500 caracteres  ({ watch('descripcion_proyecto') ? (watch('descripcion_proyecto').length)+"/500" : '0/500' })
                        </Form.Text>
                        {errors.descripcion_proyecto &&
                        <Alert style={{marginTop:'10px' }} variant="danger">
                          {errors.descripcion_proyecto?.message}
                        </Alert>
                        }
                      </Form.Group> 
                    </ListGroup.Item>             

                    <ListGroup.Item>
                      <Form.Group className="mb-3">
                        <Form.Label size="lg">Diagnóstico</Form.Label>
                        <Form.Control type="text" placeholder="Ingresar el diagnóstico..." 
                        {...register("diagnostico", 
                        {required:"El diagnóstico es obligatorio", 
                        minLength:{value:5, message: "El mínimo de caracteres para el diagnóstico es 5"}, 
                        maxLength:{value:500, message: "El máximo de caracteres para el diagnóstico es 500"}, 
                        })} 
                        isInvalid={errors.diagnostico}
                        autoComplete='off'
                        maxLength='500'
                        onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}} 
                        />
                        <Form.Text className="text-muted" muted>
                          Ingrese un máximo de 500 caracteres  ({ watch('diagnostico') ? (watch('diagnostico').length)+"/500" : '0/500' })
                        </Form.Text>
                        {errors.diagnostico &&
                        <Alert style={{marginTop:'10px' }} variant="danger">
                          {errors.diagnostico?.message}
                        </Alert>
                        }
                      </Form.Group> 
                    </ListGroup.Item> 



                    <ListGroup.Item>
                      <Form.Group className="mb-3">
                        <Form.Label size="lg">Objetivo general</Form.Label>
                        <Form.Control type="text" placeholder="Ingresar el objetivo general..." 
                        {...register("objetivo_general", 
                        {required:"El objetivo general es obligatorio", 
                        minLength:{value:5, message: "El mínimo de caracteres para el objetivo general es 5"}, 
                        maxLength:{value:100, message: "El máximo de caracteres para el objetivo general es 100"}, 
                        })} 
                        isInvalid={errors.objetivo_general}
                        autoComplete='off'
                        maxLength='100'
                        onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}} 
                        />
                        <Form.Text className="text-muted" muted>
                          Ingrese un máximo de 100 caracteres  ({ watch('objetivo_general') ? (watch('objetivo_general').length)+"/100" : '0/100' })
                        </Form.Text>
                        {errors.objetivo_general &&
                        <Alert style={{marginTop:'10px' }} variant="danger">
                          {errors.objetivo_general?.message}
                        </Alert>
                        }
                      </Form.Group> 
                    </ListGroup.Item>   

                    <ListGroup.Item>
                      <Form.Group className="mb-3">
                        <Form.Label size="lg">Objetivos específicos</Form.Label>
                        <Form.Control as="textarea" rows={4} placeholder="Ingresar los objetivos específicos del proyecto..." 
                        {...register("objetivos_especificos", 
                        {required:"Los objetivos específicos del proyecto son obligatorios", 
                        minLength:{value:5, message: "El mínimo de caracteres para los objetivos específicos es 5"}, 
                        maxLength:{value:500, message: "El máximo de caracteres para los objetivos específicos 250"}, 
                        })} 
                        isInvalid={errors.objetivos_especificos}
                        autoComplete='off'
                        maxLength='250'
                        
                        />
                        <Form.Text className="text-muted" muted>
                          Ingrese un máximo de 250 caracteres  ({ watch('objetivos_especificos') ? (watch('objetivos_especificos').length)+"/250" : '0/250' })
                        </Form.Text>
                        {errors.objetivos_especificos &&
                        <Alert style={{marginTop:'10px' }} variant="danger">
                          {errors.objetivos_especificos?.message}
                        </Alert>
                        }
                      </Form.Group> 
                    </ListGroup.Item>   


                    <ListGroup.Item>
                      <Form.Group className="mb-3">
                        <Form.Label size="lg">Antecedentes y fundamentación</Form.Label>
                        <Form.Control as="textarea" rows={4} placeholder="Ingresar los antecedentes y la fundamentación del proyecto..." 
                        {...register("antecedentes_fundamentacion", 
                        {required:"Los antecedentes y la fundamentación son obligatorios", 
                        minLength:{value:5, message: "El mínimo de caracteres para los antecedentes y la fundamentación es 5"}, 
                        maxLength:{value:500, message: "El máximo de caracteres para los antecedentes y la fundamentación es 500"}, 
                        })} 
                        isInvalid={errors.antecedentes_fundamentacion}
                        autoComplete='off'
                        maxLength='500'
                        
                        />
                        <Form.Text className="text-muted" muted>
                          Ingrese un máximo de 500 caracteres  ({ watch('antecedentes_fundamentacion') ? (watch('antecedentes_fundamentacion').length)+"/500" : '0/500' })
                        </Form.Text>
                        {errors.antecedentes_fundamentacion &&
                        <Alert style={{marginTop:'10px' }} variant="danger">
                          {errors.antecedentes_fundamentacion?.message}
                        </Alert>
                        }
                      </Form.Group> 
                    </ListGroup.Item>       

                    <ListGroup.Item>
                      <Form.Group className="mb-3">
                        <Form.Label size="lg">Beneficiarios y destinatarios del proyecto</Form.Label>
                        <Form.Control as="textarea" rows={4} placeholder="Ingresar los beneficiarios y destinatarios del proyecto..." 
                        {...register("beneficiarios_destinatarios", 
                        {required:"Los beneficiarios y destinatarios son obligatorios", 
                        minLength:{value:5, message: "El mínimo de caracteres para los beneficiarios y destinatarios es 5"}, 
                        maxLength:{value:500, message: "El máximo de caracteres para los beneficiarios y destinatarios es 500"}, 
                        })} 
                        isInvalid={errors.beneficiarios_destinatarios}
                        autoComplete='off'
                        maxLength='500'
                        
                        />
                        <Form.Text className="text-muted" muted>
                          Ingrese un máximo de 500 caracteres  ({ watch('beneficiarios_destinatarios') ? (watch('beneficiarios_destinatarios').length)+"/500" : '0/500' })
                        </Form.Text>
                        {errors.beneficiarios_destinatarios &&
                        <Alert style={{marginTop:'10px' }} variant="danger">
                          {errors.beneficiarios_destinatarios?.message}
                        </Alert>
                        }
                      </Form.Group> 
                    </ListGroup.Item>      

                           
                    <ListGroup.Item>
                      <Form.Group className="mb-3">
                        <Form.Label size="lg">Localización del proyecto</Form.Label>
                        <Form.Control as="textarea" rows={4} placeholder="Describir la localización del proyecto..." 
                        {...register("localizacion", 
                        {required:"La localización del proyecto es obligatoria", 
                        minLength:{value:5, message: "El mínimo de caracteres para la localización del proyecto es 5"}, 
                        maxLength:{value:500, message: "El máximo de caracteres para la localización del proyecto es 500"}, 
                        })} 
                        isInvalid={errors.localizacion}
                        autoComplete='off'
                        maxLength='500'
                        
                        />
                        <Form.Text className="text-muted" muted>
                          Ingrese un máximo de 500 caracteres  ({ watch('localizacion') ? (watch('localizacion').length)+"/500" : '0/500' })
                        </Form.Text>
                        {errors.localizacion &&
                        <Alert style={{marginTop:'10px' }} variant="danger">
                          {errors.localizacion?.message}
                        </Alert>
                        }
                      </Form.Group> 
                    </ListGroup.Item>                                                                        

                    <ListGroup.Item>
                      <Form.Group className="mb-3">
                        <Form.Label size="lg">Acciones y tareas</Form.Label>
                        <Form.Control as="textarea" rows={4} placeholder="Describa las acciones y tareas a realizar..." 
                        {...register("acciones_y_tareas", 
                        {required:"Las acciones y tareas del proyecto son obligatorias", 
                        minLength:{value:5, message: "El mínimo de caracteres para las acciones y tareas es 5"}, 
                        maxLength:{value:500, message: "El máximo de caracteres para las acciones y tareas es 500"}, 
                        })} 
                        isInvalid={errors.acciones_y_tareas}
                        autoComplete='off'
                        maxLength='500'
                        
                        />
                        <Form.Text className="text-muted" muted>
                          Ingrese un máximo de 500 caracteres  ({ watch('acciones_y_tareas') ? (watch('acciones_y_tareas').length)+"/500" : '0/500' })
                        </Form.Text>
                        {errors.acciones_y_tareas &&
                        <Alert style={{marginTop:'10px' }} variant="danger">
                          {errors.acciones_y_tareas?.message}
                        </Alert>
                        }
                      </Form.Group> 
                    </ListGroup.Item>  

                    

                    <ListGroup.Item>
                      <Form.Group className="mb-3">
                        <Form.Label size="lg">Recursos Humanos</Form.Label>
                        <Form.Control as="textarea" rows={4} placeholder="Describir los recursos humanos necesarios para la realización del proyecto..." 
                        {...register("recursos_humanos", 
                        {required:"Los recursos humanos necesarios son obligatorios", 
                        minLength:{value:5, message: "El mínimo de caracteres para los recursos humanos necesarios es 5"}, 
                        maxLength:{value:500, message: "El máximo de caracteres para los recursos humanos necesarios es 500"}, 
                        })} 
                        isInvalid={errors.recursos_humanos}
                        autoComplete='off'
                        maxLength='500'
                        
                        />
                        <Form.Text className="text-muted" muted>
                          Ingrese un máximo de 500 caracteres  ({ watch('recursos_humanos') ? (watch('recursos_humanos').length)+"/500" : '0/500' })
                        </Form.Text>
                        {errors.recursos_humanos &&
                        <Alert style={{marginTop:'10px' }} variant="danger">
                          {errors.recursos_humanos?.message}
                        </Alert>
                        }
                      </Form.Group> 
                    </ListGroup.Item>  

                    <ListGroup.Item>
                      <Form.Group className="mb-3">
                        <Form.Label size="lg">Recursos Materiales</Form.Label>
                        <Form.Control as="textarea" rows={4} placeholder="Describir los recursos materiales necesarios para la realización del proyecto..." 
                        {...register("recursos_materiales", 
                        {required:"Los recursos materiales necesarios son obligatorios", 
                        minLength:{value:5, message: "El mínimo de caracteres para los recursos materiales necesarios es 5"}, 
                        maxLength:{value:500, message: "El máximo de caracteres para los recursos materiales necesarios es 500"}, 
                        })} 
                        isInvalid={errors.recursos_materiales}
                        autoComplete='off'
                        maxLength='500'
                        
                        />
                        <Form.Text className="text-muted" muted>
                          Ingrese un máximo de 500 caracteres  ({ watch('recursos_materiales') ? (watch('recursos_materiales').length)+"/500" : '0/500' })
                        </Form.Text>
                        {errors.recursos_materiales &&
                        <Alert style={{marginTop:'10px' }} variant="danger">
                          {errors.recursos_materiales?.message}
                        </Alert>
                        }
                      </Form.Group> 
                    </ListGroup.Item>  

                    <ListGroup.Item>
                      <Form.Group className="mb-3">
                        <Form.Label size="lg">Recursos Financieros</Form.Label>
                        <Form.Control as="textarea" rows={4} placeholder="Describir los recursos financieros necesarios para la realización del proyecto..." 
                        {...register("recursos_financieros", 
                        {required:"Los recursos financieros necesarios son obligatorios", 
                        minLength:{value:5, message: "El mínimo de caracteres para los recursos financieros necesarios es 5"}, 
                        maxLength:{value:500, message: "El máximo de caracteres para los recursos financieros necesarios es 500"}, 
                        })} 
                        isInvalid={errors.recursos_financieros}
                        autoComplete='off'
                        maxLength='500'
                        
                        />
                        <Form.Text className="text-muted" muted>
                          Ingrese un máximo de 500 caracteres  ({ watch('recursos_financieros') ? (watch('recursos_financieros').length)+"/500" : '0/500' })
                        </Form.Text>
                        {errors.recursos_financieros &&
                        <Alert style={{marginTop:'10px' }} variant="danger">
                          {errors.recursos_financieros?.message}
                        </Alert>
                        }
                      </Form.Group> 
                    </ListGroup.Item>     

                    <ListGroup.Item>
                    <Form.Group className="mb-3">
                        <Form.Label size="lg">Monto total estimado</Form.Label>
                          <InputGroup className="mb-3">
                            <InputGroup.Text>$</InputGroup.Text>
                            <Form.Control type='text' placeholder='Monto total estimado sin puntos ni comas'
                              {...register("monto_total_estimado", 
                              {
                              required:"El monto total estimado es obligatorio",  
                              pattern:{ value: /^[0-9]+$/i, message: "Ingresar sólo números, sin espacios ni puntos"},
                              minLength:{value:3, message: "El mínimo de caracteres para el monto estimado es de 3 caracteres"}, 
                              })} 
                              isInvalid={errors.monto_total_estimado}
                              autoComplete='off'
                              maxLength='10'   
                              onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}}                          
                            />
                            <InputGroup.Text>.00</InputGroup.Text>
                          </InputGroup>  
                          {errors.monto_total_estimado &&
                          <Alert style={{marginTop:'10px' }} variant="danger">
                            {errors.monto_total_estimado?.message}
                          </Alert>
                          }
                        </Form.Group>  
                    </ListGroup.Item>                                                            



                  </ListGroup>
                </Card.Body>
              </Card>  

            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col>
            <Card>
              <Card.Header>Archivos adjuntos</Card.Header>
                  <Card.Body>  
                    <ListGroup className="list-group-flush">

                    <ListGroup.Item> 
                      <Alert variant="success">
                        Los archivos adjuntos no son obligatorios pero pueden ser útiles para aportar claridad a los proyectos.<br/>
                        El primer archivo de imagen se usará como imagen destacada del proyecto.<br/>                        
                      </Alert>                      
                    </ListGroup.Item>

                    <ListGroup.Item> 
                      <h4>Imagen principal del proyecto</h4>
                      {(proyectoActivo.imagen_destacada !=="" && proyectoActivo.imagen_destacada !==null) &&
                      <>
                      
                      <img src={`https://trenquelauquen.gov.ar/public/pp2023/uploads/${proyectoActivo.imagen_destacada}`} alt="Imagen principal" width={300} /><br/>
                      <Button variant='danger' style={{marginRight:'10px',color:'white', fontSize:'16px'}} onClick={()=>eliminarAdjunto('imagen_destacada')}> <i className="bi bi-trash-fill"></i> Eliminar la imagen</Button><br/><br/>
                      <Form.Text className="text-muted" style={{marginTop:'20px'}}>
                          Para modificar la imagen la puede eliminar y cargar una nueva imagen
                      </Form.Text> 

                      </>
                      }
                      {(proyectoActivo.imagen_destacada ==="" || proyectoActivo.imagen_destacada ===null ) &&
                      <Form.Group controlId="imagen_destacada" className="mb-3">
                        <Form.Label>Ingrese la imagen principal para su proyecto</Form.Label>
                        <Form.Control type="file" accept="image/png, image/jpeg" {...register("imagen_destacada")} />
                        <Form.Text className="text-muted" muted>
                            Esta imagen se utilizará como miniatura para mostrar su proyecto
                        </Form.Text>                           
                     
                      </Form.Group>
                      }
                    </ListGroup.Item> 

                    <ListGroup.Item> 
                    <h4>Imagen 1 del proyecto</h4>
                    {(proyectoActivo.imagen1_url !=="" && proyectoActivo.imagen1_url !== null)  &&
                      <> 
                      
                      <img src={`https://trenquelauquen.gov.ar/public/pp2023/uploads/${proyectoActivo.imagen1_url}`} alt="Imagen 1" width={300} /><br/>
                      <Button variant='danger' style={{marginRight:'10px',color:'white', fontSize:'16px'}} onClick={()=>eliminarAdjunto('imagen1_url')}> <i className="bi bi-trash-fill"></i> Eliminar la imagen</Button><br/><br/>
                      
                      <Form.Label>Ingrese una descripcion para la imagen</Form.Label>
                        <Form.Control type="text" {...register("imagen1_nombre")} placeholder='Ingrese una descripcion para la imagen' onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}}  />                       
                        <Form.Text className="text-muted" style={{marginTop:'20px'}}>
                          Para modificar la imagen la puede eliminar y cargar una nueva imagen
                      </Form.Text>                       
                      </>
                    }
                      
                    {(proyectoActivo.imagen1_url ==="" || proyectoActivo.imagen1_url === null)  &&                                            
                      <Form.Group controlId="imagen1_url" className="mb-3">
                        <Form.Label>Ingrese una imagen para su proyecto</Form.Label>
                        <Form.Control type="file" accept="image/png, image/jpeg"  {...register("imagen1_url")} />
                        <br/>
                                            
                        <Form.Label>Ingrese una descripcion para la imagen</Form.Label>
                        <Form.Control type="text" {...register("imagen1_nombre")} placeholder='Ingrese una descripcion para la imagen' /> 
                        
                        <Form.Text className="text-muted" muted>
                            Esta imagen puede ser un plano, una foto o una imagen relacionada con el proyecto o idea
                        </Form.Text>                                                  
                      </Form.Group>
                    }

                    </ListGroup.Item> 

                    <ListGroup.Item> 
                      <h4>Imagen 2 del proyecto</h4>
                    {(proyectoActivo.imagen2_url !=="" && proyectoActivo.imagen2_url !== null)  &&
                      <> 
                      
                      <img src={`https://trenquelauquen.gov.ar/public/pp2023/uploads/${proyectoActivo.imagen2_url}`} alt="Imagen 2" width={300} /><br/>
                      <Button variant='danger' style={{marginRight:'10px',color:'white', fontSize:'16px'}} onClick={()=>eliminarAdjunto('imagen2_url')}> <i className="bi bi-trash-fill"></i> Eliminar la imagen</Button><br/><br/>
                      
                      <Form.Label>Ingrese una descripcion para la imagen</Form.Label>
                        <Form.Control type="text" {...register("imagen2_nombre")} placeholder='Ingrese una descripcion para la imagen' onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}}  />                       
                        <Form.Text className="text-muted" style={{marginTop:'20px'}}>
                          Para modificar la imagen la puede eliminar y cargar una nueva imagen
                      </Form.Text>                       
                      </>
                    }  
                    {(proyectoActivo.imagen2_url ==="" || proyectoActivo.imagen2_url === null)  &&                     
                      <Form.Group controlId="imagen2_url" className="mb-3">
                        <Form.Label>Ingrese una segunda imagen para su proyecto</Form.Label>
                        <Form.Control type="file" accept="image/png, image/jpeg"  {...register("imagen2_url")} />
                        <br/>
                        <Form.Label>Ingrese una descripcion para la imagen</Form.Label>
                        <Form.Control type="text" {...register("imagen2_nombre")} placeholder='Ingrese una descripcion para la imagen' onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}}  />  
                        <Form.Text className="text-muted" muted>
                            Esta imagen puede ser un plano, una foto o una imagen relacionada con el proyecto o idea
                        </Form.Text>                                                   
                      </Form.Group>
                      }
                    </ListGroup.Item>        
                    <ListGroup.Item> 
                      <h4>Imagen 3 del proyecto</h4>
                    {(proyectoActivo.imagen3_url !=="" && proyectoActivo.imagen3_url !== null)  &&
                      <> 
                      
                      <img src={`https://trenquelauquen.gov.ar/public/pp2023/uploads/${proyectoActivo.imagen3_url}`} alt="Imagen 3" width={300} /><br/>
                      <Button variant='danger' style={{marginRight:'10px',color:'white', fontSize:'16px'}} onClick={()=>eliminarAdjunto('imagen3_url')}> <i className="bi bi-trash-fill"></i> Eliminar la imagen</Button><br/><br/>
                      
                      <Form.Label>Ingrese una descripcion para la imagen</Form.Label>
                        <Form.Control type="text" {...register("imagen3_nombre")} placeholder='Ingrese una descripcion para la imagen' onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}}  />                       
                        <Form.Text className="text-muted" style={{marginTop:'20px'}}>
                          Para modificar la imagen la puede eliminar y cargar una nueva imagen
                      </Form.Text>                       
                      </>
                    }  
                    {(proyectoActivo.imagen3_url ==="" || proyectoActivo.imagen3_url === null)  &&                              
                      <Form.Group controlId="imagen3_url" className="mb-3">
                        <Form.Label>Ingrese una tercera imagen para su proyecto</Form.Label>
                        <Form.Control type="file" accept="image/png, image/jpeg"  {...register("imagen3_url")} />
                        <br/>
                        <Form.Label>Ingrese una descripcion para la imagen</Form.Label>
                        <Form.Control type="text" {...register("imagen3_nombre")} placeholder='Ingrese una descripcion para la imagen' onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}}  />  
                        <Form.Text className="text-muted" muted>
                            Esta imagen puede ser un plano, una foto o una imagen relacionada con el proyecto o idea
                        </Form.Text>                                                   
                      </Form.Group>
                    }
                    </ListGroup.Item>                                    

                    <ListGroup.Item> 
                      <h4>Documento PDF del proyecto</h4>
                    {(proyectoActivo.documento_pdf !=="" && proyectoActivo.documento_pdf !== null)  &&
                      <> 
                      <Button style={{marginTop:'10px',marginBottom:'10px'}} href={`https://trenquelauquen.gov.ar/public/pp2023/uploads/${proyectoActivo.documento_pdf}`} variant='outline-success' target='_blank'><i className="bi bi-file-earmark-pdf"></i> Visualizar documento</Button>
                      <br/>
                      <Button variant='danger' style={{marginRight:'10px',color:'white', fontSize:'16px'}} onClick={()=>eliminarAdjunto('documento_pdf')}> <i className="bi bi-trash-fill"></i> Eliminar el documento</Button><br/><br/>
                      
                      <Form.Label>Ingrese una descripcion para el documento</Form.Label>
                        <Form.Control type="text" {...register("documento_nombre")} onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}}  /> 
                        <Form.Text className="text-muted" muted>
                          Para modificar el documento la puede eliminar y cargar una nueva imagen
                      </Form.Text>                       
                      </>
                    }   
                    {(proyectoActivo.documento_pdf ==="" || proyectoActivo.documento_pdf === null)  &&                      
                      <Form.Group controlId="documento_nombre" className="mb-3">
                        <Form.Label>Ingrese un archivo pdf con su proyecto</Form.Label>
                        <Form.Control type="file" accept="application/pdf"  {...register("documento_pdf")} />
                        <Form.Label>Ingrese una descripcion para el documento</Form.Label>
                        <Form.Control type="text" {...register("documento_nombre")} onKeyDown={e => {if (e.key === 'Enter') e.preventDefault();}}  /> 
                        <Form.Text className="text-muted" muted>
                          El documento pdf puede contener información e imágenes relacionadas al proyecto y se subirá como archivo adjunto
                        </Form.Text>                                                    
                      </Form.Group>
                    }
                    </ListGroup.Item> 

                    <ListGroup.Item> 
                      <Alert variant="warning">
                        <h4>Importante</h4>
                        El botón <strong>Presentar Proyecto</strong> carga el proyecto y lo envía a revisión. No permite hacer más cambios al proyecto cargado.
                        <br/>El botón <strong>Guardar borrador</strong> le permite seguir trabjando y guardando los cambios en otro momento ingresando al panel con su usuario y contraseña
                                           
                      </Alert>                      
                    </ListGroup.Item>                                         

                    <ListGroup.Item>                                                   
                      { visible &&
                          <Alert variant="success">
                              El registro se realizó correctamente.
                              El proyecto será analizado para su publicación
                          </Alert>    
                      }                             
                        <Button id='presentar-proyecto' variant='success' type="submit" style={{width:'200px',marginRight:'10px', marginTop:'10px'}}>Presentar proyecto</Button>
                        <Button variant='warning' style={{marginRight:'10px', marginTop:'10px'}} onClick={()=>guardarborrador(false)}>Guardar borrador del proyecto</Button> 
              
                        { guardandoProyecto &&
                        <Spinner animation="border" role="status" size='md'>
                          <span className="visually-hidden">Loading...</span>
                        </Spinner>
                        }   
                    </ListGroup.Item> 
                    <ListGroup.Item>  
                   
                    { proyectoActivo.fecha_borrador !=="" &&
                      <span>Última modificación: {proyectoActivo.fecha_borrador}</span>
                    }
                    </ListGroup.Item>
                    
                    <ListGroup.Item>                                              
                      <Button variant='secondary' id="guardarborrador"  onClick={()=>guardarborrador(true)}>Guardar y cerrar sesión</Button>   
                      <Alert style={{marginTop:'20px'}}>Al volver a ingresar puede continuar editando el proyecto</Alert>                                                             
                    </ListGroup.Item>   
                  
                  </ListGroup>

                  </Card.Body> 
            </Card>
            </Col>
          </Row>
        </Container>
      </Form> 

        } 

    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={modalShow}
      onHide={(handleClose)}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Eliminar adjunto
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>Imagen principal</h4>
        <p>
          ¿Está seguro que desea eliminar la imagen? <br/>
          Al eliminarla le permitirá subir otra imagen en su lugar<br/>
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='danger' onClick={()=>confirmarEliminar(stateAdjunto)}>Eliminar</Button>
        <Button variant='secondary' onClick={()=>setModalShow(false)}>Cancelar</Button>
        
      </Modal.Footer>
    </Modal>
    </>
  )
}

export default FormPP2023
